module.exports = __webpack_public_path__ + "resources/icon-arrow-left.a72fd51648d39550.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-accuse/img/icon-arrow-left.png
// module id = 582
// module chunks = 0 1 2 3